module.exports = __webpack_public_path__ + "img/pdf_icon.7e0ea44c.svg";